import React, {useEffect, useState} from 'react';
import {useSeanetGenres} from "../../hooks/useSeanetGenres";
import OverviewImageButtonPanel from "../../components/OverviewImageButtonPanel";
import OverviewImageButton from "../../components/OverviewImageButton";
import {withTheme} from "styled-components";
import {getSeanetUrl} from "../../actions/networkActions";
import FullScreenLoader from '../../components/FullScreenLoader';
import {setSeanetLocale, setShowSeanetLocales} from "../../actions/seanetVodActions";
import {PropTypes} from "prop-types";
import {useSelector} from "react-redux";
import {DefaultButton, DefaultButtonLink} from "../../resources/styles";
import {useSeanetLocale} from "../../hooks/useSeanetLocale";

function Genres(props, context) {
    const { seanetVodData: genres, loading, error } = useSeanetGenres();

    const allLocales = useSelector(state => state.seanetVod.allLocales);
    const {seanetLocale, backupLocale} = useSeanetLocale();
    const [retryAttempted, setRetryAttempted] = useState(false);

    useEffect(() => {
        if (allLocales && allLocales.length > 1) {
            setShowSeanetLocales(true);
        }
        return () => {
            setShowSeanetLocales(false);
        };
    }, [allLocales]);

    // Set profile's default language as seanetLocale, change in locale will trigger fetch in useSeanetGenres to re run (we assume the default lang should always have VOD titles available)
    const handleRetry = () => {
        setRetryAttempted(true);
        setSeanetLocale(backupLocale);
    }

    if (error) {
        return (
            <div className="margin-horizontal-9375">
                <p>{context.t("seanet_vod_fetch_error")}</p>
                { retryAttempted || backupLocale === seanetLocale ?
                    <DefaultButtonLink to="/">{context.t('return_to_home')}</DefaultButtonLink>
                    :
                    <DefaultButton onClick={handleRetry}>{context.t('retry_all_languages')}</DefaultButton>
                }
            </div>
        )
    }

    if(loading || !genres) {
        return <FullScreenLoader />
    }

    return (
        <div>
            <h2 className="margin-horizontal-9375">{context.t('genres')}</h2>
            <OverviewImageButtonPanel>
                {Object.values(genres).map(genre =>
                    <OverviewImageButton key={genre.id}
                                         link={"/seanetvod/genre/" + genre.id}
                                         title={genre.name}
                                         thumbnail={`${getSeanetUrl()}sti/genre-images/thumb/${genre.id === 0 ? "all.jpg" : `${genre.id}.jpg`}`}
                                         heightWidthRatio="100%"
                    />
                )}

            </OverviewImageButtonPanel>
        </div>
    );

}

Genres.contextTypes = {
    t: PropTypes.func.isRequired
}

export default  withTheme(Genres);
